class MatchingBottoms extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('product-form');
    if (!this.form || this.handleChange) return;
    this.items = Array.from(this.querySelectorAll('.matching-bottoms__item')).map(el => ({
      el, link: el.querySelector('a'), variants: JSON.parse(el.querySelector('script').textContent)
    }));
    this.handleChange = event => this.update(event.detail.selectedOptions[Number(this.dataset.colorIndex)]);
    this.form.addEventListener('on:variant:change', this.handleChange);
    const picker = this.form.querySelector('variant-picker');
    if (picker?.getSelectedOptions) this.update(picker.getSelectedOptions()[Number(this.dataset.colorIndex)]);
  }
  disconnectedCallback() {
    this.form?.removeEventListener('on:variant:change', this.handleChange);
    this.handleChange = null;
  }
  update(color) {
    let matches = 0;
    this.items.forEach(item => {
      const match = item.variants.find(variant => variant.color === color);
      item.el.hidden = !match;
      if (match) {
        const url = new URL(item.link.getAttribute('href'), location.origin);
        url.searchParams.set(item.el.dataset.colorOption, color);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        item.link.href = url.pathname + url.search;
        matches += 1;
      }
    });
    const status = this.querySelector('.matching-bottoms__status');
    if (color) status.textContent = (matches ? this.querySelector('.matching-bottoms__selected') : this.querySelector('.matching-bottoms__empty')).content.textContent.replace('[color]', color);
  }
}
customElements.define('matching-bottoms', MatchingBottoms);
